import React from 'react';
import { useSelector } from 'react-redux';

import { selectModalComponent, selectModalProps } from '../../redux/modules/modal';

import ModalContainer from './ModalContainer';

const Modal = () => {
  const Component = useSelector(selectModalComponent);
  const modalProps = useSelector(selectModalProps);

  if (!Component) return null;

  return (
    <ModalContainer>
      <Component {...modalProps} />
    </ModalContainer>
  );
};

export default Modal;
